import React from 'react';
import { Icon, Text } from '@goodfynd/ui';
import { dateUtil } from '@goodfynd/utils';
import AccordionDetails from '@mui/material/AccordionDetails';
import AccordionSummary from '@mui/material/AccordionSummary';

import config from '../../../config';
import strings from '../../../config/strings';
import type { Event } from '../../../types/events';

import EventSelectedVendors from './EventSelectedVendors';
import { StyledAccordion, StyledContainer } from './styles';
import type { EventDatesProps } from './types';
export default function EventDates({ bookedDates, data }: EventDatesProps) {
  const [expanded, setExpanded] = React.useState('');

  const handleChange =
    (dateBooked: Event) => (_e: React.SyntheticEvent, isExpanded: boolean) => {
      setExpanded(isExpanded ? dateBooked.start.toString() : '');
    };

  return (
    <>
      {bookedDates[0] ? (
        <div style={{ padding: 20 }}>
          <Text as="heading5" style={{ marginBottom: 24, marginTop: 16 }}>
            {strings.labels.thisEventTrucks}
          </Text>

          <EventSelectedVendors vendors={bookedDates[0]?.vendors} />
        </div>
      ) : null}

      {bookedDates && bookedDates.length > 1 ? (
        <StyledContainer>
          <Text as="heading5" style={{ marginBottom: 16 }}>
            {strings.labels.moreEventsAtLocation}
          </Text>

          {bookedDates.slice(1).map((dateBooked) => {
            const isExpanded = expanded === dateBooked.start.toString();

            return (
              <StyledAccordion
                expanded={isExpanded}
                key={dateBooked.start.toString()}
                onChange={handleChange(dateBooked)}
              >
                <AccordionSummary
                  expandIcon={<Icon name="chevron_down" />}
                  id={data.id}
                >
                  <Text>
                    {dateUtil.isToday(dateBooked.start)
                      ? 'TODAY'
                      : dateUtil.format(
                          dateBooked.start,
                          config.dateFormats.weekDayMonthDayYear
                        )}
                  </Text>
                </AccordionSummary>

                {isExpanded && (
                  <AccordionDetails sx={{ padding: 4, paddingTop: 2 }}>
                    <EventSelectedVendors vendors={dateBooked.vendors} />
                  </AccordionDetails>
                )}
              </StyledAccordion>
            );
          })}
        </StyledContainer>
      ) : null}
    </>
  );
}
